import { FlexRow } from '@/components/common/Flex';
import { Text } from '@/components/common/Typography';
import { configByGoalType } from '@/components/goals/config';
import { Box, FlexProps } from '@chakra-ui/react';
import { Goal } from '@common/goals';
import { getGoalDepositTransactions } from '@common/react/goals';
import pluralize from '@common/util/pluralize';
import { toPx } from '@common/util/styles';
import { FC } from 'react';
import { FlexCol } from '../common/Flex';

export interface GoalNoTargetProgressProps extends FlexProps {
    goal: Goal;
    showContributions?: boolean;
}

// Counter switches to regular progress after it hits a big enough number to avoid aliasing of the image
const SQUARED_PILL_TXNS_THRESHOLD = 32;

const GoalProgressPills: FC<GoalNoTargetProgressProps> = ({
    goal,
    showContributions,
    ...props
}) => {
    const numTxns = getGoalDepositTransactions(goal).length;
    const numDots = Math.max(4, Math.pow(2, Math.ceil(Math.log2(numTxns))));
    const dots = Array.from({ length: numDots }, (d, i) => ({
        isComplete: i < numTxns,
    }));

    const config = configByGoalType[goal.type];

    const useSquarePills = numTxns > SQUARED_PILL_TXNS_THRESHOLD;

    return (
        <FlexCol {...props} justifyContent="center">
            <FlexRow
                flexGrow="unset"
                justifyContent="space-between"
                gap={toPx(useSquarePills ? 0 : 1)}
                h={toPx(5)}
                w="full"
            >
                {dots.map((d, index) => (
                    <Box
                        key={index}
                        flex={1}
                        borderRadius={useSquarePills ? 0 : 8}
                        bg={d.isComplete ? config.color : 'gray.100'}
                    />
                ))}
            </FlexRow>
            {showContributions && (
                <Text fontSize="sm" color="grey" mt={2}>
                    {pluralize(
                        config.group === 'HIGH_YIELD_CASH_ONLY'
                            ? 'contribution'
                            : 'investment',
                        numTxns,
                        true
                    )}{' '}
                    so far
                </Text>
            )}
        </FlexCol>
    );
};

export default GoalProgressPills;
